import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 6.371c0 4.418 -2.239 6.629 -5 6.629","key":"svg-0"}],["path",{"d":"M4 6.371h7","key":"svg-1"}],["path",{"d":"M5 9c0 2.144 2.252 3.908 6 4","key":"svg-2"}],["path",{"d":"M12 20l4 -9l4 9","key":"svg-3"}],["path",{"d":"M19.1 18h-6.2","key":"svg-4"}],["path",{"d":"M6.694 3l.793 .582","key":"svg-5"}]]

const IconLanguage = createReactComponent('outline', 'language', 'Language', __iconNode);

export default IconLanguage;